import React, { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { LeftArrow, RightArrow } from 'shared/assets/icons';
import "./paginationhoc.scss"



const PaginationHOC = ({ list, renderItem, title, explore, count, notitle ,leftright}) => {
    const containerRef = useRef(null);
    const parentRef = useRef(null);
    const [pageLoading, setpageLoading] = useState(false)
    const [currentindex, setcurrentindex] = useState(1)
    const [rowcount, setrowcount] = useState(1)
    const [screenwidth, setscreenwidth] = useState(window.innerWidth)

    useEffect(() => {
        getWidth()
        window.addEventListener('resize', () => {
            getWidth()
        });
        return () => {
        }
    }, [list])
    const getWidth = () => {
        let width = window?.innerWidth
        setscreenwidth(width)
        let countInRow = count
        if(width < 500) {
            countInRow = 1
        } else if(width < 800) {
            countInRow = 2
        } else if(width < 1100) {
            countInRow = 3
        }
        width = width - (width * 8 / 100)
        setrowcount(countInRow)
        return ({ countInRow,  currentindex })
        // handleScroll(-1)
    }
    useEffect(() => {
        const container = containerRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll);
            container.addEventListener('scrollend', handleScroll);
        }
        return () => {
            if (container) {
                container.removeEventListener('scroll', handleScroll);
                container.removeEventListener('scrollend', handleScroll);
            }
        };
    }, [currentindex]);

    const handleScroll = (event) => {
        const container = containerRef.current;
        if ( event.target.scrollLeft + event.target.clientWidth >= event.target.scrollWidth - 1 ) {
            setcurrentindex( Math.ceil(list?.length / rowcount)-1 );
        } else {
            setcurrentindex(Math.round(container.scrollLeft / container.offsetWidth));
        }
    };
   
    useEffect(() => {
        const container = containerRef.current;
        if (container) {
         container.scrollLeft = (currentindex) * (container.offsetWidth );
        }
      }, [currentindex]);

    return (
        <div className={"paginationhoc"} ref={parentRef} >
            {!notitle && <div className='header'>
                <text className='title'>{title}</text>
                <div role={"button"} className={`linkview`} onClick={() => {
                    explore("Trending Now Explore All ")
                }}>Explore All</div>
            </div>}
            {!pageLoading && <div className="pagpeView d-flex align-items-center">
                {(leftright ? screenwidth >= 800 : false) &&<div role={"button"} className={`navbtnlr ${containerRef.current?.scrollLeft == 0 ? "inactivebtn" : ""}`} onClick={() => {   setcurrentindex(currentindex-1) }}>{LeftArrow}</div>}
                <div className="horizontalview"  ref={containerRef}>
                    <div className="carousel-container">
                        {list?.length > 0 &&
                            list.map((item, index) => (
                                <div
                                    className="carousel-column"
                                    key={index}
                                    style={{ flex: `0 0 ${(100) / rowcount}%` }}
                                >
                                    {renderItem(item, index)}
                                </div>
                            ))}
                    </div>
                </div>
                    {(leftright ? screenwidth >= 800 : false) &&<div role={"button"} className={`navbtnlr ${containerRef.current?.scrollLeft + containerRef.current?.clientWidth >= containerRef.current?.scrollWidth ? "inactivebtn" : ""}`} onClick={() => {   setcurrentindex(currentindex+1) }}>{RightArrow}</div>}
            </div>}

            {(leftright ? screenwidth < 800 : true) && <div className='page-box'>
                {
                    Math.ceil(list?.length / rowcount) > 1 && [...Array(Math.ceil(list?.length / rowcount))].map((item, index) => (
                        <div role={"button"} onClick={() => {
                            setcurrentindex(index)
                        }} className={`dot ${index == currentindex ? "active-dot" : ""}`}></div>
                    ))
                }
            </div>}

        </div>
    );
};

export default PaginationHOC;

